<template>
	
</template>

<script>
	export default {
		//生命周期函数
		created() {
			let that = this;
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let code = that.GetUrlParame('code') // 截取code 
			if (code==undefined) {
				let wxurl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2c333bf0404cf8ea&redirect_uri=http://sl.zhishen.net.cn/author&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect';
				window.location.href = wxurl;
			} else {
				let formdataCode = new FormData();
				formdataCode.append('code', code);
				that.$axios.post('http://sls.zhishen.net.cn/api/User/weChatLogin', formdataCode)
				.then(function (res) {
					localStorage.setItem('userId', res.data.userinfo.user_id)
					localStorage.setItem('token', res.data.userinfo.token)
// 					if(res.data.userinfo.mobile == ''){
// 						//that.$router.push({path: '/bindphone?pageUrl=' + localStorage.getItem('beforeUrl')});
// 						window.location.replace(that.login.pageUrl + '/bindphone');
// 					}else{
// 						window.location.href = localStorage.getItem('beforeUrl')
// 						localStorage.removeItem('beforeUrl')
// 					}
 					window.location.href = localStorage.getItem('beforeUrl')
 					localStorage.removeItem('beforeUrl')
					let tokenTime = res.data.userinfo.expiretime
					let nowTime = Math.round(new Date().getTime()/1000).toString();
					if(tokenTime<nowTime){
						localStorage.removeItem('token')
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			}
		},
		data() {
			return { 
			};
		},
		methods:{
			// 截取code
			GetUrlParame (parameName) {
				/// 获取地址栏指定参数的值
				/// <param name="parameName">参数名</param>
				// 获取url中跟在问号后面的部分
				var parames = window.location.search
				// 检测参数是否存在
				if (parames.indexOf(parameName) > -1) {
					var parameValue = ''
					parameValue = parames.substring(parames.indexOf(parameName), parames.length)
					// 检测后面是否还有参数
					if (parameValue.indexOf('&') > -1) {
					  // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
					  parameValue = parameValue.substring(0, parameValue.indexOf('&'))
					  // 去掉参数名, 得到最终纯值字符串
					  parameValue = parameValue.replace(parameName + '=', '')
					  return parameValue
					}
					return ''
				}
			} 
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/login/author.vue